import * as React from "react";
import { forwardRef } from "react";
const HatSVG = (props, ref) => React.createElement("svg", { width: 24, height: 24, viewBox: "0 0 24 24", ref: ref, ...props },
    React.createElement("path", { fillRule: "evenodd", d: "M12.441 3.112a.92.92 0 0 0-.883 0L2.265 8.13c-.353.19-.353.725 0 .916l9.293 5.017c.278.15.606.15.883 0l9.294-5.017c.353-.191.353-.726 0-.916zm-.87 11.996-5.343-2.884v5.194c3.188 3.443 8.357 3.443 11.545 0v-5.194l-5.342 2.884a.9.9 0 0 1-.86 0", clipRule: "evenodd" }));
const ForwardRef = forwardRef(HatSVG);
export default ForwardRef;
//# sourceMappingURL=Hat.js.map